import { useLanguage } from '../contexts/LanguageContext';
import { portalCopy, type PortalCopyKey } from './copy';

export function usePortalCopy() {
  const { language, setLanguage } = useLanguage();
  return { language, setLanguage, p: (key: PortalCopyKey) => portalCopy[language][key] };
}
